module.exports = __webpack_public_path__ + "static/princeton_signature-b84d11718cbc78b13ef0475ca913547d.svg";